import React from 'react';
import { ExternalSourceTypes } from 'src/actions/integrations/commonTypes';
import { EditorOptions } from './types';

export const customActionEditorOptions = (hasCustomActionSettings: boolean): EditorOptions => {
  return {
    header: (
      <>
        Actions allow your agents to stay in Gladly to perform tasks they would usually complete elsewhere. You can
        learn more about actions in our{' '}
      </>
    ),
    mainSwitchHeadingText: 'Actions',
    mainSwitchEnabledText: (
      <span>Turning off actions will result in your agents not being able to use actions in Gladly.</span>
    ),
    mainSwitchDisabledText: (
      <span>
        Turning on actions will result in your agents being able to use actions in Gladly.
        {hasCustomActionSettings && ' You will be able to select the actions that are turned on for your organization.'}
      </span>
    ),
  };
};

export const supportedActionEditorOptions = (
  hasCustomActionSettings: boolean,
  integrationLabel: string
): EditorOptions => {
  return {
    header: (
      <>
        Actions allow your agents to stay in Gladly to perform tasks they would usually complete in {integrationLabel}.
        You can learn more about {integrationLabel} actions in our{' '}
      </>
    ),
    mainSwitchHeadingText: `Actions for ${integrationLabel}`,
    mainSwitchEnabledText: (
      <span>
        Turning off actions will result in your agents not being able to use {integrationLabel} actions in Gladly.
      </span>
    ),
    mainSwitchDisabledText: (
      <span>
        Turning on actions will result in your agents being able to use {integrationLabel} actions in Gladly.
        {hasCustomActionSettings && ' You will be able to select the actions that are turned on for your organization.'}
      </span>
    ),
  };
};

export const getActionEditorOptions = (
  integrationType: ExternalSourceTypes,
  hasCustomActionSettings: boolean,
  integrationLabel: string
) => {
  switch (integrationType) {
    case ExternalSourceTypes.Custom:
      return customActionEditorOptions(hasCustomActionSettings);

    default:
      return supportedActionEditorOptions(hasCustomActionSettings, integrationLabel);
  }
};
